import { TextBadge, TextBadgeColor, TextBadgeSize } from "@bps/fluent-ui";
import { Permission } from "@libs/gateways/core/CoreGateway.dtos.ts";
import { EpisodeOfCare } from "@stores/clinical/models/EpisodeOfCare.ts";
import { useStores } from "@stores/hooks/useStores.ts";

import { EpisodeOfCareBadgesLabels } from "./condition-modal/Condition.types.ts";

interface ClaimBadgesProps {
  episodeOfCare: EpisodeOfCare;
}

export const EpisodeOfCareBadges: React.FC<ClaimBadgesProps> = ({
  episodeOfCare
}) => {
  const { core } = useStores();

  const showBadge = core.hasPermissions(Permission.ClaimRead);
  const getBadgeJSX = (text: string) => (
    <TextBadge
      key={text}
      badgeSize={TextBadgeSize.small}
      badgeColor={TextBadgeColor.blue}
    >
      {text}
    </TextBadge>
  );

  const getBadges = () => {
    const badges = [];
    badges.push(getBadgeJSX(episodeOfCare.primaryDiagnosis));

    if (
      showBadge &&
      episodeOfCare.claim?.claimNumber &&
      !episodeOfCare.referralNumber
    ) {
      badges.push(getBadgeJSX(episodeOfCare.claim.claimNumber));
    }

    if (showBadge && episodeOfCare.isPrivate) {
      badges.push(getBadgeJSX(EpisodeOfCareBadgesLabels.Private));
    }

    if (episodeOfCare.referralNumber) {
      badges.push(
        getBadgeJSX(EpisodeOfCareBadgesLabels.Referred),
        getBadgeJSX(episodeOfCare.referralNumber)
      );
    }

    if (showBadge && episodeOfCare.claim?.isOnHold) {
      badges.push(getBadgeJSX(EpisodeOfCareBadgesLabels.OnHold));
    }
    return badges;
  };

  return <>{getBadges()}</>;
};
